import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.promise.finally.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { equals } from '../../../base/common/arrays.js';
import { CancellationTokenSource } from '../../../base/common/cancellation.js';
import { onUnexpectedExternalError } from '../../../base/common/errors.js';
import { LRUCache } from '../../../base/common/map.js';
import { DocumentSymbolProviderRegistry } from '../../common/modes.js';
import { Iterable } from '../../../base/common/iterator.js';
import { MovingAverage } from '../../../base/common/numbers.js';
export var TreeElement = /*#__PURE__*/function () {
  function TreeElement() {
    _classCallCheck(this, TreeElement);
  }

  _createClass(TreeElement, [{
    key: "remove",
    value: function remove() {
      if (this.parent) {
        this.parent.children.delete(this.id);
      }
    }
  }], [{
    key: "findId",
    value: function findId(candidate, container) {
      // complex id-computation which contains the origin/extension,
      // the parent path, and some dedupe logic when names collide
      var candidateId;

      if (typeof candidate === 'string') {
        candidateId = "".concat(container.id, "/").concat(candidate);
      } else {
        candidateId = "".concat(container.id, "/").concat(candidate.name);

        if (container.children.get(candidateId) !== undefined) {
          candidateId = "".concat(container.id, "/").concat(candidate.name, "_").concat(candidate.range.startLineNumber, "_").concat(candidate.range.startColumn);
        }
      }

      var id = candidateId;

      for (var i = 0; container.children.get(id) !== undefined; i++) {
        id = "".concat(candidateId, "_").concat(i);
      }

      return id;
    }
  }, {
    key: "empty",
    value: function empty(element) {
      return element.children.size === 0;
    }
  }]);

  return TreeElement;
}();
export var OutlineElement = /*#__PURE__*/function (_TreeElement) {
  _inherits(OutlineElement, _TreeElement);

  var _super = _createSuper(OutlineElement);

  function OutlineElement(id, parent, symbol) {
    var _this;

    _classCallCheck(this, OutlineElement);

    _this = _super.call(this);
    _this.id = id;
    _this.parent = parent;
    _this.symbol = symbol;
    _this.children = new Map();
    return _this;
  }

  return OutlineElement;
}(TreeElement);
export var OutlineGroup = /*#__PURE__*/function (_TreeElement2) {
  _inherits(OutlineGroup, _TreeElement2);

  var _super2 = _createSuper(OutlineGroup);

  function OutlineGroup(id, parent, label, order) {
    var _this2;

    _classCallCheck(this, OutlineGroup);

    _this2 = _super2.call(this);
    _this2.id = id;
    _this2.parent = parent;
    _this2.label = label;
    _this2.order = order;
    _this2.children = new Map();
    return _this2;
  }

  return OutlineGroup;
}(TreeElement);
export var OutlineModel = /*#__PURE__*/function (_TreeElement3) {
  _inherits(OutlineModel, _TreeElement3);

  var _super3 = _createSuper(OutlineModel);

  function OutlineModel(uri) {
    var _this3;

    _classCallCheck(this, OutlineModel);

    _this3 = _super3.call(this);
    _this3.uri = uri;
    _this3.id = 'root';
    _this3.parent = undefined;
    _this3._groups = new Map();
    _this3.children = new Map();
    _this3.id = 'root';
    _this3.parent = undefined;
    return _this3;
  }

  _createClass(OutlineModel, [{
    key: "_compact",
    value: function _compact() {
      var count = 0;

      var _iterator = _createForOfIteratorHelper(this._groups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              _group = _step$value[1];

          if (_group.children.size === 0) {
            // empty
            this._groups.delete(key);
          } else {
            count += 1;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (count !== 1) {
        //
        this.children = this._groups;
      } else {
        // adopt all elements of the first group
        var group = Iterable.first(this._groups.values());

        var _iterator2 = _createForOfIteratorHelper(group.children),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                child = _step2$value[1];

            child.parent = this;
            this.children.set(child.id, child);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return this;
    }
  }], [{
    key: "create",
    value: function create(textModel, token) {
      var _this4 = this;

      var key = this._keys.for(textModel, true);

      var data = OutlineModel._requests.get(key);

      if (!data) {
        var source = new CancellationTokenSource();
        data = {
          promiseCnt: 0,
          source: source,
          promise: OutlineModel._create(textModel, source.token),
          model: undefined
        };

        OutlineModel._requests.set(key, data); // keep moving average of request durations


        var now = Date.now();
        data.promise.then(function () {
          var key = _this4._keys.for(textModel, false);

          var avg = _this4._requestDurations.get(key);

          if (!avg) {
            avg = new MovingAverage();

            _this4._requestDurations.set(key, avg);
          }

          avg.update(Date.now() - now);
        });
      }

      if (data.model) {
        // resolved -> return data
        return Promise.resolve(data.model);
      } // increase usage counter


      data.promiseCnt += 1;
      token.onCancellationRequested(function () {
        // last -> cancel provider request, remove cached promise
        if (--data.promiseCnt === 0) {
          data.source.cancel();

          OutlineModel._requests.delete(key);
        }
      });
      return new Promise(function (resolve, reject) {
        data.promise.then(function (model) {
          data.model = model;
          resolve(model);
        }, function (err) {
          OutlineModel._requests.delete(key);

          reject(err);
        });
      });
    }
  }, {
    key: "_create",
    value: function _create(textModel, token) {
      var cts = new CancellationTokenSource(token);
      var result = new OutlineModel(textModel.uri);
      var provider = DocumentSymbolProviderRegistry.ordered(textModel);
      var promises = provider.map(function (provider, index) {
        var _a;

        var id = TreeElement.findId("provider_".concat(index), result);
        var group = new OutlineGroup(id, result, (_a = provider.displayName) !== null && _a !== void 0 ? _a : 'Unknown Outline Provider', index);
        return Promise.resolve(provider.provideDocumentSymbols(textModel, cts.token)).then(function (result) {
          var _iterator3 = _createForOfIteratorHelper(result || []),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var info = _step3.value;

              OutlineModel._makeOutlineElement(info, group);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return group;
        }, function (err) {
          onUnexpectedExternalError(err);
          return group;
        }).then(function (group) {
          if (!TreeElement.empty(group)) {
            result._groups.set(id, group);
          } else {
            group.remove();
          }
        });
      });
      var listener = DocumentSymbolProviderRegistry.onDidChange(function () {
        var newProvider = DocumentSymbolProviderRegistry.ordered(textModel);

        if (!equals(newProvider, provider)) {
          cts.cancel();
        }
      });
      return Promise.all(promises).then(function () {
        if (cts.token.isCancellationRequested && !token.isCancellationRequested) {
          return OutlineModel._create(textModel, token);
        } else {
          return result._compact();
        }
      }).finally(function () {
        listener.dispose();
      });
    }
  }, {
    key: "_makeOutlineElement",
    value: function _makeOutlineElement(info, container) {
      var id = TreeElement.findId(info, container);
      var res = new OutlineElement(id, container, info);

      if (info.children) {
        var _iterator4 = _createForOfIteratorHelper(info.children),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var childInfo = _step4.value;

            OutlineModel._makeOutlineElement(childInfo, res);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      container.children.set(res.id, res);
    }
  }]);

  return OutlineModel;
}(TreeElement);
OutlineModel._requestDurations = new LRUCache(50, 0.7);
OutlineModel._requests = new LRUCache(9, 0.75);
OutlineModel._keys = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this._counter = 1;
    this._data = new WeakMap();
  }

  _createClass(_class, [{
    key: "for",
    value: function _for(textModel, version) {
      return "".concat(textModel.id, "/").concat(version ? textModel.getVersionId() : '', "/").concat(this._hash(DocumentSymbolProviderRegistry.all(textModel)));
    }
  }, {
    key: "_hash",
    value: function _hash(providers) {
      var result = '';

      var _iterator5 = _createForOfIteratorHelper(providers),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var provider = _step5.value;

          var n = this._data.get(provider);

          if (typeof n === 'undefined') {
            n = this._counter++;

            this._data.set(provider, n);
          }

          result += n;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return result;
    }
  }]);

  return _class;
}())();